import React, { useState } from 'react';

import { useAppContext } from '@prisjakt/ui-app-context';

import { H2Text, TitleSmallText } from '@prisjakt/ui/text/variants';
import { PrimaryButton } from '@prisjakt/ui/button/variants';
import { Column } from '@prisjakt/ui/list/variants';
import { FormModal } from './form';

import { pushEvent } from 'src/client/data-layer';

import { Content, Wrapper, Prompt } from './styles';

import { BaseProps } from './types';

type Props = BaseProps;

export const UXFeedbackPrompt = (props: Props) => {
  const {
    className,
    formId,
    title,
    description,
    storageId,
    utilityTitle,
    usabilityTitle,
    presentationTitle,
  } = props;

  const { t } = useAppContext();
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(true);

  const handleClick = () => {
    setOpen(state => !state);
    // Track feedback form being opened
    pushEvent(`${formId}Opened`);
  };

  return (
    <>
      {open && (
        <FormModal
          isOpen={open}
          closeModal={() => setOpen(false)}
          formId={formId}
          storageId={storageId}
          title={title}
          utilityTitle={utilityTitle}
          usabilityTitle={usabilityTitle}
          presentationTitle={presentationTitle}
          onSubmit={() => setVisible(false)}
        />
      )}

      {visible && (
        <Wrapper className={className}>
          <Prompt>
            <Content>
              <Column gap={1}>
                <H2Text>{title}</H2Text>
                <TitleSmallText>{description}</TitleSmallText>

                <PrimaryButton
                  onClick={handleClick}
                  style={{ maxWidth: 'max-content', margin: 'auto' }}
                >
                  {t('feedback', 'uup.prompt-button')}
                </PrimaryButton>
              </Column>
            </Content>
          </Prompt>
        </Wrapper>
      )}
    </>
  );
};
